module.exports = __webpack_public_path__ + "img/GHS-pictogram-explos.67b91339.png";